import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class Tibbit39Node extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 39';
        this.id = 'node_tibbit_39';
        this.linkedFeature = 'tibbit_39_1';

        this.inputs = [
            {
                name: 'Turn On/Off',
                portId: 'tibbit39_on_off',
                params: [
                    {
                        name: 'state',
                        dataType: TibboDataType.BOOLEAN,
                        default: '0',
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const tibbit = project.getFeature(this.getSettingValue('TIBBIT'));
        if (!tibbit) {
            return blocks;
        }
        const name = tibbit.getSettingValue('NAME');
        const ledIO = name.concat('_LED');

        const links = project.getNodeLinks(this, 'tibbit39_on_off');
        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `
    io.num=${ledIO}
    io.state=${project.getNodeParameter(link, 'state')}`,
            });
        }

        return blocks;
    }
}
